import {intlShape, utils} from '@wallaby-ui/core';
import * as React from 'react';
import {defineMessages, injectIntl} from 'react-intl';

import ScreenInfoMessage from './ScreenInfoMessage';

const I18N = defineMessages({
  INVALID: {
    id: 'autoLayout.invalid.text',
    defaultMessage:
      'Data was modified by another user. The form should be reloaded.',
    description: 'text for invalid screen in auto layout',
  },
});

const InvalidScreen = ({intl}) => (
  <ScreenInfoMessage
    text={utils.TranslateUtils.translate(I18N.INVALID, intl)}
  />
);

InvalidScreen.displayName = 'InvalidScreen';

InvalidScreen.propTypes = {
  intl: intlShape.isRequired,
};

export default injectIntl(InvalidScreen);
